import { Store, useStore } from 'vuex';
import API from '../../api';

export interface CompanyUsersStoreState {
  isLoading: boolean;
  isError: boolean;
  data: any;
  meta: any;
  error?: any;
}

export const CompanyUsersStoreImpl = {
  namespaced: true,

  state: (): CompanyUsersStoreState => ({
    isLoading: false,
    isError: false,
    data: null,
    meta: {}
  }),

  actions: {
    async updateState({ state }: { state: CompanyUsersStoreState }, args: { doUpdate: (state: CompanyUsersStoreState) => Promise<any> }) {
      return await args.doUpdate(state);
    }
  }
};

export class CompanyUsersStore {
  private store: Store<any>;

  public constructor(store: Store<any> | undefined = null) {
    this.store = store ? store : useStore();
  }

  public get state(): CompanyUsersStoreState {
    return this.store.state.companyUsers;
  }

  public dispatch<T>(doUpdate: (state: CompanyUsersStoreState) => Promise<T>): Promise<T> {
    return this.store.dispatch('companyUsers/updateState', { doUpdate });
  }

  public async init(params: any) {
    this.dispatch(async (state) => {
      try {
        state.isLoading = true;
        const res = await API.get('company/users', params);
        state.data = res.data.data;
        state.meta = res.data.meta;
        state.isLoading = false;
        state.isError = false;
        state.error = null;
      } catch (error) {
        state.isLoading = false;
        state.isError = true;
        state.error = error;
      }
    });
  }
}
